module.exports = __webpack_public_path__ + "img/get-on-the-move.cab76587.jpg";